import React from 'react';
import {  Typography } from '@material-ui/core';
import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles(() => ({

    description: {
        fontSize: "1.6em",
        color: "#231F20",
        fontFamily: "Inter",
        marginTop:'2%',
        marginBottom:'2%',
        fontWeight: "normal",
        borderBottom: '1px solid rgba(224, 224, 224, 1)'
    },

}));


interface ITextStepTitleProps {
    text: string; 
}

export default function StepTitle(props: ITextStepTitleProps) {
    
    const classes = useStyles();

    return (
        <Typography className = { classes.description }>
            {props.text}
         </Typography>
    );
}